/* globals jQuery, site_data */
import 'fitvids.1.1.0'
//import 'flexslider'
import 'magnific-popup'
//import Swiper from 'swiper';
//NOTE: Trying to import swiper this way caused IE 11 to throw a syntax error so it is being enqueued seperatly

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import tabs from './jquery.tabs.js'

import sticky from './stickey-header.js';
import speedbumb from './speedbump.js';

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion
    $.fn.tabs = tabs

    //OPEN SEARCH POPUP
	$('.open-search').magnificPopup({
	  type:'inline',
	  alignTop: true,
	  modal: true,
	  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	  mainClass: 'mfp-fade mfp-fullscreen'
	});

	$(document).on('click', '.close-search', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});


    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    //this feels a bit hacky but i haven't been able to figure out how to hide or remove the breadcrumbs when only containing 1 item
    if( $('.breadcrumbs > span').length < 2 ){
        $('.breadcrumbs').addClass('hide');
    }

    //amplify banner animation
    setTimeout(function(){
        $('.banner--animate').addClass('animated');
    },500);

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();
    $('.tabs').tabs();

    //product template view options toggle
    $('.toggle-btn').on('click', function(e){
        e.preventDefault();

        $(this).closest('.toggle-parent').find('.toggle-area').slideToggle();

        var btnText = $(this).find('span').text();
        $(this).find('span').text(btnText == 'Show' ? 'Hide' : 'Show');
    });

    //alerts
    $('.site-alert__close').on('click',function(e){
        e.preventDefault();
        //fade out content
        $(this).parent().addClass("fade");
        //slide up pattern
        $(this).closest('.site-alert').delay(300).slideUp('slow', 'swing');
    });

    /**
	* jQuery function to prevent default anchor event and take the href * and the title to make a share popup
	*
	* @param  {[object]} e           [Mouse event]
	* @param  {[integer]} intWidth   [Popup width defalut 500]
	* @param  {[integer]} intHeight  [Popup height defalut 400]
	* @param  {[boolean]} blnResize  [Is popup resizeabel default true]
	*/
	$.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {

	// Prevent default anchor event
	e.preventDefault();

	// Set values for window
	intWidth = intWidth || '500';
	intHeight = intHeight || '400';
	var strResize = (blnResize ? 'yes' : 'no');

	// Set title and open popup with focus on it
	var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
		strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
		objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
	};

	$('.share').on("click", function(e) {
	  $(this).customerPopup(e);
	});


    /* SWIPER JS - HOMEPAGE TABS & TESTIMONIAL SLIDESHOW */
    $(document).ready(function () {

	    if($(".js-home-slides .swiper-slide").length > 1) {
		    var homeSlides = new Swiper('.js-home-slides', {
			    loop: true,
			    speed: 500,
			    autoplay: {
				    delay: 4000,
				    disableOnInteraction: true,
			    },
			    pagination: {
				    el: '.swiper-pagination',
				    clickable: true,
			    },
			    navigation: {
				    nextEl: '.swiper-next',
				    prevEl: '.swiper-prev',
			    },
			    parallax: true,
			    direction: 'vertical',
			    effect: 'fade',
			    watchOverflow: true,
			    fadeEffect: {
				    crossFade: true
			    },

		    });
	    };
	    
	    var basicSlides = new Swiper('.js-basic-slides', {
            loop: true,
            effect: "fade",
            preloadImages: true,
            updateOnImagesReady : true,
            pagination: {
                el: '.swiper-pagination'
            },
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            }
        });

       var testimonials = new Swiper('.js-testimonial-slides', {
           loop: true,
           effect: "fade",
           preloadImages: true,
           updateOnImagesReady : true,
           autoHeight: true,
           watchOverflow: true,
           fadeEffect: {
               crossFade: true
           },
           navigation: {
               nextEl: '.swiper-next',
               prevEl: '.swiper-prev',
           }
       });
       /* not understanding why this is needed but otherwise the height keeps getting cut off */
       if( $('.js-testimonial-slides').length > 0 ){
           setTimeout(function(){
               testimonials.updateAutoHeight();
           },500);
       }

       //homepage tabs
       var activeIndex = $('.hometabs__tabs').data('tab-active');

       var mySwiper = new Swiper('.js-swiper-hometabs', {
           slidesPerView: 7,
           freeMode: true,
           initialSlide: 3,
           watchOverflow: true,
           threshold: 5,
           breakpoints: {
               1023 : {
                   slidesPerView: 6,
                   centeredSlides: true
               },
               850 : {
                   slidesPerView: 4,
                   centeredSlides: true
               },
               750 : {
                   slidesPerView: 2,
                   centeredSlides: true,
                   initialSlide: activeIndex
               }

           }
       });

       //on load set correct tab as active
       var setTabActive = function(index){
           var index = index;

           //remove active class from all other boxes/tabcontent
           $('.hometabs__tabs .icon-box').removeClass('active');
           $('.hometab__content').removeClass('active');

           //add active class to icon box
           $('.hometabs__tabs .icon-box').eq(index).addClass('active');

           //make proper content active
           $('.hometab__content').eq(index).addClass('active');
       }

       setTabActive(activeIndex);
       $('.hometabs__tabs .icon-box').on('click',function(e){
           e.preventDefault();
           var setIndex = $(this).index();
           console.log(setIndex);
           setTabActive(setIndex);
       });

   });

})(jQuery)
